import validate from './LaneSheetHeatAddFormValidation';

import Constants from "@usas/ui-web/utils/Constants";
import UseForm from "@usas/ui-web/utils/UseForm";

const INITIAL_FORM_STATE = {
  heatNumber: '',
  sessionTypeId: '',
  sessionTypeName: '',
  heatDate: '',
  heatDateId: Constants.DEFAULT_ID,
  eventNameAndDistanceId: []
};

const useLaneSheetHeatAddForm = (onSubmitFormCallback) => {
  const { formState, errorState, updateFormState, onValueTextPairChanged, handleSubmit 
  } = UseForm(INITIAL_FORM_STATE, onSubmitFormCallback, validate);

  return {
    formState,
    errorState,
    handleSubmit,
    onFormValueChanged: updateFormState,
    onValueTextPairChanged
  };
};

export default useLaneSheetHeatAddForm;